import { render } from "./InputPhone.vue?vue&type=template&id=60f3d7a2&scoped=true"
import script from "./InputPhone.vue?vue&type=script&lang=js"
export * from "./InputPhone.vue?vue&type=script&lang=js"

import "./InputPhone.vue?vue&type=style&index=0&id=60f3d7a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f3d7a2"]])

export default __exports__